import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    contentText: {
      marginBottom: theme.spacing(2),
    },
  })
);
